import Widget from 'components/Widget/Widget';
import React from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import PropTypes from 'prop-types';
import StatsByAdAccountTable from './components/StatsByAdAccountTable';

const StatsByAdAccount = ({ height, data, index, configuration }) => {
  return (
    <Widget
      tableWidget
      widget_key={'network_total_statistics' + index}
      title={data.title}
      index={index}
      disableLimit
      disableLevelFilter
      data={data}
      disableStatusFilter
      default_filter={data.defaultFilter}
      configuration={configuration}
      adsFilter
      adsetFilter
      campaignFilter
      disableDateFilter
      showDatePicker
      showNetworkSwitcher
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <StatsByAdAccountTable widget_key={'network_total_statistics' + index} height={height} />
    </Widget>
  );
};

export default StatsByAdAccount;

StatsByAdAccount.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
};
